import { ADVANTAGE_LIST } from '../index.js';
import AdvantageCard from './AdvantageCard';
export default {
  components: {
    AdvantageCard
  },
  data() {
    return {
      advantageList: ADVANTAGE_LIST
    };
  }
};